import React from "react";
import { Descriptions } from "antd";
import {
	usePreguntasPuntualidad,
	usePreguntasComunicacionReportes,
} from "../../hooks";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasPredisposicion from "../../hooks/usePreguntasPredisposicion";
import usePreguntasImagenRepresentacionEmpresa from "../../hooks/usePreguntasImagenRepresentacionEmpresa";
import useResultadoEvaluacionConductor from "../../hooks/useResultadoEvaluacionConductor";

const FactoresEvaluacionConductor = () => {
	const { puntajeTotal: puntajeTotalPuntualidad } = usePreguntasPuntualidad();
	const { puntajeTotal: puntajeTotalComunicacionReportes } = usePreguntasComunicacionReportes();
	const { puntajeTotal: puntajeTotalResponsabilidadManejoVehiculo } = usePreguntasResponsabilidadManejoVehiculo();
	const { puntajeTotal: puntajeTotalActitudTrabajoEquipo } = usePreguntasActitudTrabajoEquipo();
	const { puntajeTotal: puntajeTotalPredisposicion } = usePreguntasPredisposicion();
	const { puntajeTotal: puntajeTotalImagenRepresentacionEmpresa } = usePreguntasImagenRepresentacionEmpresa();
	const { puntajeTotalEvaluacionConductor } = useResultadoEvaluacionConductor();
	return (
		<div style={{ marginBottom: "20px" }}>
			<div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "5px" }}>FACTORES DE EVALUACIÓN</div>
			<Descriptions bordered size="small" column={1} labelStyle={{ width: "70%" }}>
				<Descriptions.Item label="PUNTUALIDAD">
					{puntajeTotalPuntualidad}
				</Descriptions.Item>
				<Descriptions.Item label="COMUNICACIÓN Y REPORTES">
					{puntajeTotalComunicacionReportes}
				</Descriptions.Item>
				<Descriptions.Item label="RESPONSABILIDAD Y MANEJO DEL VEHICULO">
					{puntajeTotalResponsabilidadManejoVehiculo}
				</Descriptions.Item>
				<Descriptions.Item label="ACTITUD Y TRABAJO EN EQUIPO">
					{puntajeTotalActitudTrabajoEquipo}
				</Descriptions.Item>
				<Descriptions.Item label="PREDISPOSICION">
					{puntajeTotalPredisposicion}
				</Descriptions.Item>
				<Descriptions.Item label="IMAGEN Y REPRESENTACION EN LA EMPRESA">
					{puntajeTotalImagenRepresentacionEmpresa}
				</Descriptions.Item>
				<Descriptions.Item label="TOTAL">
					{puntajeTotalEvaluacionConductor}
				</Descriptions.Item>
			</Descriptions>
		</div>
	);
};

export default FactoresEvaluacionConductor;
